import { EntityPreviewsLayout } from "../../shared/layouts/EntityPreviewsLayout";
import { BondRequestPreviewsAll } from "./BondRequestPreviewsAll";
import { BondRequestPreviewsClosed } from "./BondRequestPreviewsClosed";
import { BondRequestPreviewsOpen } from "./BondRequestPreviewsOpen";

export const RequestsView = () => {
	return (
		<EntityPreviewsLayout
			title="Bond Requests"
			storageKey="requests_view"
			tabs={[
				{
					id: "all",
					label: "All",
					Component: BondRequestPreviewsAll,
				},
				{
					id: "open",
					label: "Open",
					isDefault: true,
					Component: BondRequestPreviewsOpen,
				},
				{
					id: "closed",
					label: "Closed",
					Component: BondRequestPreviewsClosed,
				},
			]}
		/>
	);
};
